export class UploadFileReport {
    fileName: string;
    file: File;
}
